export const isDarkColorHSP = (hexColor: string): boolean => {
  if (!hexColor) return false;
  // Преобразование HEX в RGB
  const r = parseInt(hexColor?.slice(1, 3), 16);
  const g = parseInt(hexColor?.slice(3, 5), 16);
  const b = parseInt(hexColor?.slice(5, 7), 16);

  // Расчет яркости по модели HSP (Human Perception)
  const brightness = Math.sqrt(
    0.299 * r ** 2 + 0.587 * g ** 2 + 0.114 * b ** 2
  );

  // Если яркость < 150, цвет считается "темным" (по HSP)
  return brightness < 150;
};
